import AudienceModel from "../../audience/_model/AudienceModel";
import {AppMode, DEFAULT_STORAGE_URL, EngineMode} from "./app.constants";
import ContentAppModel from "./ContentAppModel";
import ModuleModel from "./ModuleModel";
import ProjectConfigModel from "../../project/_model/ProjectConfigModel";

export class AppModel {
    public mode = AppMode.PRODUCTION;
    public engineMode: EngineMode = EngineMode.PRESENT;
    public storageUrl = DEFAULT_STORAGE_URL;
    public apiUrl = "";
    public authToken = "";

    public userId = 0;

    public audience: AudienceModel = new AudienceModel();

    public projectConfig: ProjectConfigModel = new ProjectConfigModel();

    // CONTENT APP?
    public contentApp: ContentAppModel = new ContentAppModel();

    // MODULE?
    public module: ModuleModel = new ModuleModel();
}
